module.exports = __webpack_public_path__ + "static/media/avatar.fc14abd5.png";